export default {
  master_title: 'Mode marque - Menu',
  title: 'Menu',
  form: {
    has_internal_product_numbers: {
      label: 'Attribuer des numéros aux produits',
      tooltip:
        'Attribuer automatiquement des numéros aux produits selon leur position dans le menu. Le numéro est imprimé sur les reçus',
    },
  },
  buttons: {
    new_menu: 'Nouveau menu',
    export_menu: 'Exporter le menu',
    refresh: 'Actualiser',
  },
  modals: {
    delete_category: {
      title: 'Supprimer {{name}}',
    },
    delete_products: {
      title: 'Supprimer {{count}} produits ?',
      description: '<strong>{{count}}</strong> seront supprimés du menu',
    },
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_delete_menu: 'Impossible de supprimer le menu, veuillez réessayer',
    menu_got_deleted: 'Menu supprimé',
    failed_to_delete_category: 'Impossible de supprimer la catégorie, veuillez réessayer',
    category_got_deleted: 'Catégorie supprimée',
    failed_to_delete_products: 'Impossible de supprimer les produits, veuillez réessayer',
    product_got_deleted_one: 'Produit supprimé',
    product_got_deleted_other: 'Produits supprimés',
    failed_to_generate_product_number: 'Une erreur est survenue. Veuillez recharger la page et réessayer',
    menu_exported: 'Menu exporté',
    failed_to_export_menu: "Échec de l'exportation du menu",
  },
};
